/**
 * スマホ判定フック(2026-08-28)。CSSと同じ 900px を閾値にする(縦向きタブレットも含める・2026-08-31)(仕様書: 閾値は必ず一致させる)。
 * 一覧の表示切替(申請一覧=C案の列絞り込み / フロー画面=A案のカード表示)に使用
 */
import { useEffect, useState } from 'react';

const QUERY = '(max-width: 900px)';

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(QUERY).matches : false,
  );
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return mobile;
}
